import React, { useCallback } from 'react'
import { fetchDepartmentAisleProducts } from 'legacy/common/api'
import { type FetchProductsInjectedProps, type FetchAisleProductsFn } from './types'
import { fetchMeshAisleProductsWithInfo } from './fetchMeshAisleProductsWithInfo'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'
import { useQueryParam } from 'use-query-params'
import { stringQueryParamEncoder } from 'utils/query-params/string.utils'

export const withFetchAisleProducts = <T extends React.ComponentType<FetchProductsInjectedProps>>(
  Component: T
): T => {
  const EnhancedComponent = (props: React.ComponentProps<T>) => {
    const { warehouse } = useWarehouseContext()
    const [localeCodeFromQueryParams] = useQueryParam('locale', stringQueryParamEncoder)
    const localeCode = localeCodeFromQueryParams || warehouse.defaultLocale.localeCode

    const fetchProducts: FetchAisleProductsFn = useCallback(
      (...args) =>
        props.useMesh
          ? fetchMeshAisleProductsWithInfo(localeCode?.toUpperCase(), ...args)
          : fetchDepartmentAisleProducts(...args),
      [props.useMesh, localeCode]
    )

    // @ts-expect-error, ts is crazy. but everything is properly typed inside and outside this function
    return <Component {...props} fetchProducts={fetchProducts} useMesh={props.useMesh} />
  }

  return EnhancedComponent as T
}
